import { StyledBannerContainer } from './BannerContainer.styled';

export const BannerContainer = ({ children }) => {
  if (!children) return null;
  return <StyledBannerContainer>{children}</StyledBannerContainer>;
};

export default BannerContainer;
